module.exports = __webpack_public_path__ + "static/media/close-white.14213624.svg";